import React, { useState, useEffect, useCallback, useRef } from 'react';
import { User, DollarSign, FileText, AlertCircle, X, Check, Briefcase} from 'lucide-react';
import { formatearFechaCompleta, formatearPrecio } from '../../../../utils/utils';
import { useContabilidadModel } from '../../../../modelos/Contabilidad/modeloContabilidad';
import { useRetornoAsesor } from '../../../../config/unificacion';
import { useConfiguracion } from '../../../../metodos/ConfiguracionContext';
import { useListasModel } from '../../../../modelos/listas/modeloListas';
import CreatableSelect from 'react-select/creatable';

// ✅ ESTADO EXTERNO - PERSISTE ENTRE RE-RENDERS
let modalState = {
  step: 1,
  isProcessing: false,
  hasBeenOpened: false,
  servicioData: null,
  updateCliente: null,
};

const ModalAgendarTrabajo = ({ 
  showModal, 
  onClose, 
  cotizacion, 
  solicitud, 
  cliente,
  onServicioAgendado,
}) => {

  const{
    retornarIdentificadorCodigo,
    retornoAsesor,
  } = useRetornoAsesor();

  const {
    carrerasOptions,
    cargarCarreras,
    universidadesOptions,
    cargarUniversidades,
  } = useListasModel();

  //cargar carreras y universidades
  useEffect(() =>{
    cargarCarreras();
    cargarUniversidades();
  },[])

  // ✅ CERRAR MODAL CON TECLA ESCAPE
  useEffect(() => {
    const handleEscapeKey = (event) => {
      // Solo cerrar si está abierto el modal y no está procesando
      if (showModal && event.key === 'Escape' && !modalState.isProcessing) {
        console.log("⌨️ Escape presionado - cerrando modal");
        onClose();
      } else if (showModal && event.key === 'Escape' && modalState.isProcessing) {
        console.log("🛡️ Escape bloqueado - modal procesando");
      }
    };

    // Solo agregar el listener si el modal está abierto
    if (showModal) {
      document.addEventListener('keydown', handleEscapeKey);
      
      // Cleanup: remover el listener cuando el modal se cierre o el componente se desmonte
      return () => {
        document.removeEventListener('keydown', handleEscapeKey);
      };
    }
  }, [showModal, onClose]); 

  console.log("entrando cotizacion ",cotizacion);

  const [servicioData, setServicioData] = useState({
    materia: solicitud.materia || '',
    identificadorcodigo: retornarIdentificadorCodigo(solicitud),
    preciotutor: cotizacion?.cotizacion ||0,
    preciocobrado: cotizacion?.cotizacion * 2 ||0,
    cliente: solicitud?.cliente || 0,
    fechasistema: new Date(),
    fechaentrega: solicitud.fechaentrega,
    tutor: cotizacion?.nombretutor,
    idsolicitud : solicitud.id,
    entregatutorFecha: new Date(2023, 0, 1),
    referidoPor: solicitud.referidoPor,
    codigoReferenciaCamapa: solicitud.codigoReferenciaCamapa,
  });
  
  console.log("la data queda",servicioData);

  const [updateCliente, setUpdateCliente] = useState({
    nombreCliente: cliente.nombreCliente || '',
    nombrecompletoCliente: cliente.nombrecompletoCliente, 
    universidad: cliente.universidad,
    carrera: cliente.carrera,
    numero: cliente?.numero || solicitud?.cliente || 0,
    nombre: cliente?.nombre,
    apellido: cliente.apellido,
    correoElectronico: cliente.correoElectronico,
  });
  const clienteRef = useRef(updateCliente); 

  const esProspecto = (
      !cliente?.nombreCliente || 
      !cliente?.nombrecompletoCliente ||
      cliente?.nombreCliente === "PROSPECTO" || 
      cliente?.nombreCliente === "PROSPECTO CLIENTE" ||
      cliente?.nombrecompletoCliente === "PROSPECTO" || 
      cliente?.nombrecompletoCliente === "PROSPECTO CLIENTE" ||
      cliente?.nombre === "" ||
      cliente.correoElectronico === ""
    );

  const { 
    configuracion, 
    loadingConfiguracion, 
  } = useConfiguracion();

  const [errors, setErrors] = useState({});
  
  // ✅ ESTADO PROTEGIDO DEL STEP
  const [step, setStepLocal] = useState(modalState.step);
  const [isProcessing, setIsProcessingLocal] = useState(modalState.isProcessing);
  
  const {
    addServicio,
  } = useContabilidadModel();

  // ✅ FUNCIÓN PROTEGIDA PARA CAMBIAR STEP
  const setStep = useCallback((newStep) => {
    if (!modalState.isProcessing) {
      modalState.step = newStep;
      setStepLocal(newStep);
      console.log("📍 Step cambió a:", newStep);
    } else {
      console.log("🛡️ Cambio de step bloqueado - procesando");
    }
  }, []);

  // ✅ FUNCIÓN PARA MANEJAR EL PROCESAMIENTO
  const setProcessing = useCallback((processing) => {
    modalState.isProcessing = processing;
    setIsProcessingLocal(processing);
    console.log(processing ? "🔒 Bloqueando modal" : "🔓 Desbloqueando modal");
  }, []);

  // ✅ SINCRONIZAR ESTADO AL ABRIR EL MODAL
  useEffect(() => {
    if (showModal) {
      if (!modalState.hasBeenOpened) {
        // Primera vez que se abre
        console.log("🆕 Primera apertura del modal");
        modalState.step = 1;
        modalState.isProcessing = false;
        modalState.hasBeenOpened = true;
        setStepLocal(1);
        setIsProcessingLocal(false);
        setErrors({});
      } else {
        // Re-apertura - mantener estado
        console.log("🔄 Re-apertura del modal - manteniendo estado");
        setStepLocal(modalState.step);
        setIsProcessingLocal(modalState.isProcessing);
      }
    }
  }, [showModal]);

  // ✅ PROTEGER CONTRA RESETS DURANTE RE-RENDERS
  useEffect(() => {
    if (showModal && modalState.step !== step && !modalState.isProcessing) {
      console.log("🛡️ Protegiendo step - restaurando de", step, "a", modalState.step);
      setStepLocal(modalState.step);
    }
  });

  //estado de update cliente
  useEffect(() => {
    clienteRef.current = updateCliente;
  }, [updateCliente]);

  // ✅ LOGGING CONTROLADO
  useEffect(() => {
    if (showModal && !isProcessing) {
      console.log("📍 Step cambió a:", step);
    }
  }, [step, showModal, isProcessing]);

  //handle input changue
  const handleServicioChange = (field, value) => {
    setServicioData(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Limpiar error del campo
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: null
      }));
    }
  };

  const handleClienteChange = (field, value) => {
    console.log("handle cliente",field,value);
    setUpdateCliente(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Limpiar error del campo
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: null
      }));
    }
  };

  const handleSelectChange = (selectedOption, actionMeta) => {
    console.log("option",selectedOption);
    console.log("action",actionMeta);
    console.log('Select cambió:', actionMeta.name, selectedOption?.value);
    const value = selectedOption?.value || actionMeta.value;
    
    const fieldName = actionMeta.name;
    const clienteFields = ['universidad', 'carrera'];
    
    if (clienteFields.includes(fieldName)) {
      handleClienteChange(fieldName, value);
    } else {
      handleServicioChange(fieldName, value);
    } 
  };

  const validateStep = (currentStep) => {
    const newErrors = {};
    
    const clienteActual = clienteRef.current;

    if (currentStep === 1) {
      if (!servicioData.preciotutor || servicioData.preciotutor <= 0) {
        newErrors.preciotutor = 'El precio del tutor es requerido';
      }
      if (!servicioData.preciocobrado || servicioData.preciocobrado <= 0) {
        newErrors.preciocobrado = 'El precio cobrado es requerido';
      }
    }

    if (currentStep === 2) {
      console.log("a revisar",updateCliente);
      if (esProspecto || servicioData.modoEdicion) {
        if (!clienteActual.nombre || clienteActual.nombre.trim() === '') {
          newErrors.nombre = 'El nombre es requerido';
        }
        if (!clienteActual.nombrecompletoCliente || clienteActual.nombrecompletoCliente.trim() === '') {
          newErrors.nombrecompletoCliente = 'El nombre completo es requerido';
        }
        if (!clienteActual.nombreCliente || clienteActual.nombreCliente.trim() === '') {
          newErrors.nombreCliente = 'El nombre de WhatsApp es requerido';
        }

        //El correo electronico toca bregar a sacarlo, pero no podemos obligar
      } else {
        if (!cliente?.nombreCliente) {
          newErrors.cliente = 'Información del cliente no disponible';
        }
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ✅ NAVEGACIÓN PROTEGIDA
  const handleNext = useCallback(() => {
    if (modalState.isProcessing) {
      console.log("🛡️ Navegación bloqueada - procesando");
      return;
    }
    
    if (validateStep(step)) {
      setStep(step + 1);
    }
  }, [step, setStep]);

  const handlePrevious = useCallback(() => {
    if (modalState.isProcessing) {
      console.log("🛡️ Navegación bloqueada - procesando");
      return;
    }
    setStep(step - 1);
  }, [step, setStep]);

  //algo que se repite mucho
  const getOptionFromValue = (options, value) => {
    if (!value || !options || options.length === 0) return null;
    return options.find(option => option.value === value) || null;
  };

  // ✅ FUNCIÓN CONFIRMAR SERVICIO PROTEGIDA
  const confirmarServicio = useCallback(async() => {
    if (modalState.isProcessing) {
      console.log("🛡️ Ya está procesando - ignorando");
      return;
    }

    try {
      console.log("🚀 Iniciando confirmación de servicio");
      setProcessing(true);

      // Guardar datos en el estado externo
      modalState.servicioData = servicioData;
      modalState.updateCliente = updateCliente;

      //agregar creadoPor
      servicioData.creadoPor = retornoAsesor();

      const respuestaAddServicio = await  addServicio(servicioData, updateCliente, solicitud.nombreEmpresa, esProspecto);

      if(!respuestaAddServicio){
        return;
      }
      
      console.log("✅ Servicio confirmado exitosamente");
      
      // ✅ CERRAR MODAL Y RESETEAR ESTADO EXTERNO
      setTimeout(() => {
        setProcessing(false);
        modalState.step = 1;
        modalState.hasBeenOpened = false;
        modalState.servicioData = null;
        modalState.updateCliente = null;
        onClose();
        onServicioAgendado(respuestaAddServicio);
      }, 1500);

    } catch(error) {
      console.error("❌ Error al confirmar servicio:", error);
      setProcessing(false);
    }
  }, [servicioData, updateCliente, solicitud.nombreEmpresa, esProspecto, addServicio, onClose, setProcessing]);

  // ✅ CIERRE PROTEGIDO
  const handleClose = useCallback(() => {
    if (!modalState.isProcessing) {
      modalState.step = 1;
      modalState.hasBeenOpened = false;
      modalState.servicioData = null;
      modalState.updateCliente = null;
      onClose();
    } else {
      console.log("🛡️ Cierre bloqueado - procesando");
    }
  }, [onClose]);

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        
        {/* ✅ OVERLAY DE PROCESAMIENTO */}
        {isProcessing && (
          <div className="absolute inset-0 bg-white bg-opacity-95 flex items-center justify-center z-10 rounded-lg">
            <div className="text-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-2"></div>
              <p className="text-sm text-gray-600 font-medium">Procesando solicitud...</p>
              <p className="text-xs text-gray-500 mt-1">No cierre esta ventana</p>
            </div>
          </div>
        )}

        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b border-gray-200">
          <div>
            <h2 className="text-xl font-bold text-gray-900">Agendar Trabajo</h2>
            <p className="text-sm text-gray-600">
              ID Solicitud: {solicitud?.id} | Tutor: {cotizacion?.nombretutor}
            </p>
            {isProcessing && (
              <p className="text-xs text-amber-600 mt-1">
                ⚠️ Procesando - No cerrar
              </p>
            )}
          </div>
          <button
            onClick={handleClose}
            disabled={isProcessing}
            className="text-gray-400 hover:text-gray-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <X size={24} />
          </button>
        </div>

        {/* Progress Steps */}
        <div className="px-6 py-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            {[1, 2, 3].map((stepNumber) => (
              <div key={stepNumber} className="flex items-center">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${
                  step >= stepNumber 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-gray-200 text-gray-600'
                } ${isProcessing ? 'opacity-75' : ''}`}>
                  {step > stepNumber ? <Check size={16} /> : stepNumber}
                </div>
                <span className={`ml-2 text-sm ${
                  step >= stepNumber ? 'text-blue-600 font-medium' : 'text-gray-500'
                } ${isProcessing ? 'opacity-75' : ''}`}>
                  {stepNumber === 1 && 'Datos del Trabajo'}
                  {stepNumber === 2 && 'Cliente'}
                  {stepNumber === 3 && 'Confirmación'}
                </span>
                {stepNumber < 3 && (
                  <div className={`w-12 h-0.5 mx-4 ${
                    step > stepNumber ? 'bg-blue-600' : 'bg-gray-200'
                  } ${isProcessing ? 'opacity-75' : ''}`} />
                )}
              </div>
            ))}
          </div>
        </div>

        <div>
          <div className="p-6">
            {/* Step 1: Datos del Trabajo */}
            {step === 1 && (
              <div className="space-y-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Datos del Trabajo</h3>
                
                {/* Información de la cotización */}
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-medium text-blue-900 mb-2">Cotización Seleccionada</h4>
                  <div className="grid grid-cols-2 gap-4 text-sm">
                    <div>
                      <span className="text-blue-700">Tutor:</span>
                      <span className="ml-2 font-medium">{cotizacion.nombretutor}</span>
                    </div>
                    <div>
                      <span className="text-blue-700">Precio Cotizado:</span>
                      <span className="ml-2 font-medium">{cotizacion.cotizacion}</span>
                    </div>
                  </div>
                </div>

                {/* Precios */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      <DollarSign size={16} className="inline mr-1" />
                      Precio Tutor
                    </label>
                    <div className="w-full p-3 border border-gray-300 rounded-md bg-gray-50 font-medium">
                      {formatearPrecio(servicioData.preciotutor)}
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      <DollarSign size={16} className="inline mr-1" />
                      Precio Cobrado
                    </label>
                    <input
                      type="number"
                      value={servicioData.preciocobrado}
                      onChange={(e) => handleServicioChange('preciocobrado', parseFloat(e.target.value) || 0)}
                      disabled={isProcessing}
                      className={`w-full p-3 border rounded-md disabled:opacity-50 ${
                        errors.preciocobrado ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder="25000"
                    />
                    {errors.preciocobrado && (
                      <p className="text-red-500 text-xs mt-1">{errors.preciocobrado}</p>
                    )}
                  </div>
                </div>

                {/* Ganancia calculada */}
                {servicioData.preciocobrado > 0 && servicioData.preciotutor > 0 && (
                  <div className="bg-green-50 p-4 rounded-lg">
                    <h4 className="font-medium text-green-900 mb-2">Resumen Financiero</h4>
                    <div className="grid grid-cols-3 gap-4 text-sm">
                      <div>
                        <span className="text-green-700">Ganancia:</span>
                        <span className="ml-2 font-bold text-green-900">
                          {formatearPrecio(servicioData.preciocobrado - servicioData.preciotutor)}
                        </span>
                      </div>
                      <div>
                        <span className="text-green-700">Margen:</span>
                        <span className="ml-2 font-bold text-green-900">
                          {((servicioData.preciocobrado - servicioData.preciotutor) / servicioData.preciocobrado * 100).toFixed(1)}%
                        </span>
                      </div>
                      <div>
                        <span className="text-green-700">Total Cliente:</span>
                        <span className="ml-2 font-bold text-green-900">
                          {formatearPrecio(servicioData.preciocobrado)}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Step 2: Cliente */}
            {step === 2 && (
              <div className="space-y-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Información del Cliente</h3>
                
                {(() => {
                  if (esProspecto) {
                    return (
                      <>
                        <div className="bg-amber-50 border border-amber-200 p-4 rounded-lg">
                          <h4 className="font-medium text-amber-900 mb-2 flex items-center">
                            <AlertCircle size={16} className="mr-2" />
                            Cliente Prospecto Detectado
                          </h4>
                          <p className="text-amber-700 text-sm">
                            Este cliente aparece como "PROSPECTO". Complete la información real del cliente para continuar.
                          </p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          {/* Nombre Whatsapp */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              <User size={16} className="inline mr-1" />
                              Nombre WhatsApp *
                            </label>
                            <input
                              type="text"
                              value={updateCliente.nombreCliente || ""}
                              onChange={(e) => handleClienteChange('nombreCliente', e.target.value)}
                              disabled={isProcessing}
                              className={`w-full p-3 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 ${
                                errors.nombreCliente ? 'border-red-500' : 'border-gray-300'
                              }`}
                              placeholder="Como aparece en WhatsApp"
                              required
                            />
                            {errors.nombreCliente && (
                              <p className="text-red-500 text-xs mt-1">{errors.nombreCliente}</p>
                            )}
                          </div>

                          {/* Nombre Completo */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              <FileText size={16} className="inline mr-1" />
                              Nombre Completo *
                            </label>
                            <input
                              type="text"
                              value={updateCliente.nombrecompletoCliente || ""}
                              onChange={(e) => handleClienteChange('nombrecompletoCliente', e.target.value)}
                              disabled={isProcessing}
                              className={`w-full p-3 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 ${
                                errors.nombrecompletoCliente ? 'border-red-500' : 'border-gray-300'
                              }`}
                              placeholder="Nombre completo del cliente"
                              required
                            />
                            {errors.nombrecompletoCliente && (
                              <p className="text-red-500 text-xs mt-1">{errors.nombrecompletoCliente}</p>
                            )}
                          </div>

                          {/* Nombre */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              <FileText size={16} className="inline mr-1" />
                              Nombre *
                            </label>
                            <input
                              type="text"
                              value={updateCliente.nombre || ""}
                              onChange={(e) => handleClienteChange('nombre', e.target.value)}
                              disabled={isProcessing}
                              className={`w-full p-3 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 ${
                                errors.nombre ? 'border-red-500' : 'border-gray-300'
                              }`}
                              placeholder="Nombre completo del cliente"
                              required
                            />
                            {errors.nombre && (
                              <p className="text-red-500 text-xs mt-1">{errors.nombre}</p>
                            )}
                          </div>

                          {/* Apellido */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              <FileText size={16} className="inline mr-1" />
                              Apellido
                            </label>
                            <input
                              type="text"
                              value={updateCliente.apellido || ""}
                              onChange={(e) => handleClienteChange('apellido', e.target.value)}
                              disabled={isProcessing}
                              className={`w-full p-3 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 ${
                                errors.apellido ? 'border-red-500' : 'border-gray-300'
                              }`}
                              placeholder="Nombre completo del cliente"
                              required
                            />
                            {errors.apellido && (
                              <p className="text-red-500 text-xs mt-1">{errors.apellido}</p>
                            )}
                          </div>

                          {/* Correo electronico */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              <FileText size={16} className="inline mr-1" />
                              Correo electronico *
                            </label>
                            <input
                              type="text"
                              value={updateCliente.correoElectronico || ""}
                              onChange={(e) => handleClienteChange('correoElectronico', e.target.value)}
                              disabled={isProcessing}
                              className={`w-full p-3 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 ${
                                errors.correoElectronico ? 'border-red-500' : 'border-gray-300'
                              }`}
                              placeholder="Nombre completo del cliente"
                              required
                            />
                            {errors.correoElectronico && (
                              <p className="text-red-500 text-xs mt-1">{errors.correoElectronico}</p>
                            )}
                          </div>

                          {/* Universidad */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Universidad
                            </label>
                            <CreatableSelect
                              name="universidad"
                              value={updateCliente.universidad ? { label: updateCliente.universidad, value: updateCliente.universidad } : null}
                              onChange={(option) => handleSelectChange(null, { ...option, name: 'universidad' })}
                              options={universidadesOptions}
                              placeholder="Selecciona una universidad"
                              isClearable
                              isSearchable
                              isDisabled={isProcessing}
                              className="mb-4"
                            />
                          </div>

                          {/* Carrera */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Carrera
                            </label>
                            <CreatableSelect
                              name="carrera"
                              value={updateCliente.carrera ? { label: updateCliente.carrera, value: updateCliente.carrera } : null}
                              onChange={(option) => handleSelectChange(null, { ...option, name: 'carrera' })}
                              options={carrerasOptions}
                              placeholder="Selecciona una carrera"
                              isClearable
                              isSearchable
                              isDisabled={isProcessing}
                              className="mb-4"
                            />
                          </div>


                        </div>

                        <div className="bg-blue-50 p-4 rounded-lg">
                          <h4 className="font-medium text-blue-900 mb-2">Información del Cliente</h4>
                          <div className="grid grid-cols-2 gap-4 text-sm">
                            <div>
                              <span className="text-blue-700">Número:</span>
                              <span className="ml-2 font-medium">{solicitud?.cliente || 'No disponible'}</span>
                            </div>
                            <div>
                              <span className="text-blue-700">Procedencia:</span>
                              <span className="ml-2 font-medium">{cliente?.procedencia || 'No especificada'}</span>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  } else {
                    return (
                      <>
                        <div className="bg-green-50 border border-green-200 p-4 rounded-lg">
                          <h4 className="font-medium text-green-900 mb-2 flex items-center">
                            <Check size={16} className="mr-2" />
                            Cliente Registrado
                          </h4>
                          <p className="text-green-700 text-sm">
                            La información del cliente ya está disponible en el sistema.
                          </p>
                        </div>

                        <div className="bg-white border border-gray-200 p-4 rounded-lg">
                          <h4 className="font-medium text-gray-900 mb-4">Datos del Cliente</h4>
                          
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-3">
                              <div>
                                <label className="text-sm text-gray-600">Nombre WhatsApp</label>
                                <p className="font-medium text-gray-900">{cliente?.nombreCliente}</p>
                              </div>
                              
                              <div>
                                <label className="text-sm text-gray-600">Nombre Completo</label>
                                <p className="font-medium text-gray-900">{cliente?.nombrecompletoCliente}</p>
                              </div>

                               <div>
                                <label className="text-sm text-gray-600">Nombre</label>
                                <p className="font-medium text-gray-900">{cliente?.nombre}</p>
                              </div>

                              <div>
                                <label className="text-sm text-gray-600">Apellido</label>
                                <p className="font-medium text-gray-900">{cliente?.apellido}</p>
                              </div>

                              <div>
                                <label className="text-sm text-gray-600">Correo electronico</label>
                                <p className="font-medium text-gray-900">{cliente?.correoElectronico}</p>
                              </div>

                            </div>

                            <div className="space-y-3">
                              <div>
                                <label className="text-sm text-gray-600">Universidad</label>
                                <p className="font-medium text-gray-900">{cliente?.universidad || 'No especificada'}</p>
                              </div>
                              
                              <div>
                                <label className="text-sm text-gray-600">Carrera</label>
                                <p className="font-medium text-gray-900">{cliente?.carrera || 'No especificada'}</p>
                              </div>
                            </div>
                          </div>

                          <div className="mt-4 pt-4 border-t border-gray-200">
                            <div className="grid grid-cols-2 gap-4 text-sm">
                              <div>
                                <span className="text-gray-600">Número:</span>
                                <span className="ml-2 font-medium">{solicitud?.cliente}</span>
                              </div>
                              <div>
                                <span className="text-gray-600">Procedencia:</span>
                                <span className="ml-2 font-medium">{cliente?.procedencia || 'No especificada'}</span>
                              </div>
                            </div>
                          </div>

                          {/* --- Sección de Estadísticas --- */}
                          <div className="mt-6">
                            <div className="flex items-center gap-2 mb-4">
                              <Briefcase className="w-5 h-5 text-indigo-600" />
                              <h4 className="text-lg font-semibold text-gray-800">Estadísticas del Cliente</h4>
                            </div>

                            {/* --- Tarjetas individuales para cada estadística --- */}
                            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
                              <div className="bg-blue-50/70 border border-blue-100 p-3 rounded-md text-center">
                                <span className="text-xs font-medium text-gray-600 block">Servicios Agendados</span>
                                <p className="text-xl font-bold text-gray-900">{cliente?.estadisticasCliente?.totalServicios}</p>
                              </div>
                              <div className="bg-blue-50/70 border border-blue-100 p-3 rounded-md text-center">
                                <span className="text-xs font-medium text-gray-600 block">Solicitudes</span>
                                <p className="text-xl font-bold text-gray-900">{cliente?.estadisticasCliente?.totalSolicitudes}</p>
                              </div>
                              <div className="bg-blue-50/70 border border-blue-100 p-3 rounded-md text-center">
                                <span className="text-xs font-medium text-gray-600 block">Invertido Total</span>
                                <p className="text-xl font-bold text-gray-900">{formatearPrecio(cliente?.estadisticasCliente?.gastoTotal)}</p>
                              </div>
                              <div className="bg-blue-50/70 border border-blue-100 p-3 rounded-md text-center">
                                <span className="text-xs font-medium text-gray-600 block">Conversión</span>
                                <p className="text-xl font-bold text-gray-900">{cliente?.estadisticasCliente?.conversionSolicitudesServicio}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  }
                })()} 
              </div>
            )}

            {/* Step 3: Confirmación */}
            {step === 3 && (
              <div className="space-y-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Confirmación</h3>
                
                <div className="bg-gray-50 p-6 rounded-lg space-y-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <span className="text-gray-600 text-sm">Tutor:</span>
                      <p className="font-medium">{cotizacion?.nombretutor}</p>
                    </div>
                    <div>
                      <span className="text-gray-600 text-sm">Cliente:</span>
                      <p className="font-medium">
                        {cliente.numero} - {cliente.nombreCliente}
                      </p>
                    </div>
                    <div>
                      <span className="text-gray-600 text-sm">Precio Tutor:</span>
                      <p className="font-medium text-blue-600">{formatearPrecio(servicioData.preciotutor)}</p>
                    </div>
                    <div>
                      <span className="text-gray-600 text-sm">Precio Cobrado:</span>
                      <p className="font-medium text-green-600">{formatearPrecio(servicioData.preciocobrado)}</p>
                    </div>
                  </div>

                  <div className="border-t border-gray-200 pt-4">
                    <span className="text-gray-600 text-sm">Ganancia:</span>
                    <p className="font-bold text-green-600 text-lg">
                      {formatearPrecio(servicioData.preciocobrado - servicioData.preciotutor)}
                    </p>
                  </div>
                </div>

                <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                  <div className="flex items-start">
                    <AlertCircle className="text-amber-600 mr-2 mt-0.5" size={16} />
                    <div className="text-amber-800 text-sm">
                      <p className="font-medium">Importante:</p>
                      <p>Al confirmar, se creará el trabajo y se notificará a ambas partes.</p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Footer con botones PROTEGIDOS */}
          <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-between">
            <div>
              {step > 1 && (
                <button
                  type="button"
                  onClick={handlePrevious}
                  disabled={isProcessing}
                  className="px-4 py-2 text-gray-600 hover:text-gray-800 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  ← Anterior
                </button>
              )}
            </div>
            
            <div className="flex gap-3">
              <button
                type="button"
                onClick={handleClose}
                disabled={isProcessing}
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isProcessing ? 'Procesando...' : 'Cancelar'}
              </button>
              
              {step < 3 ? (
                <button
                  type="button"
                  onClick={handleNext}
                  disabled={isProcessing}
                  className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Siguiente →
                </button>
              ) : (
                <button
                  onClick={confirmarServicio}
                  disabled={isProcessing}
                  className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                >
                  {isProcessing ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                      Procesando...
                    </>
                  ) : (
                    'Confirmar y Agendar'
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalAgendarTrabajo;